import { Row, Col, Typography } from 'antd'
import { Link } from 'react-router-dom'
import LoginForm from 'container/LoginForm'

const { Title } = Typography

const Login = () => {
	return (
		<Row justify='center' align='middle' className='full-height'>
			<Col xs={20} md={10} xl={4}>
				<Row justify='center' align='middle'>
					<Title>Logins</Title>
				</Row>
				<LoginForm />
				<Row justify='center' align='middle'>
					<Link to='/forgot-password'> Forgot Password</Link>
				</Row>
			</Col>
		</Row>
	)
}

export default Login
